import { Card, FiltersT } from '../..'
import { DataT } from '../../Map/utils/types'
import { Flex, Text } from '@chakra-ui/react'
import { LoadingAnimation } from 'components'
import StackedDiseasesByCountry from 'modules/BioriskMpox/common/StackedDiseasesByCountry'
import { LayerT } from '../../Map/layers'

const EpiDiseaseByCountry = ({
  filters,
  selectCountry,
  countryData,
  layers,
}: {
  filters: FiltersT
  selectCountry: (country: string) => void
  countryData: DataT[] | undefined
  layers?: {
    mapLayers: string[] | undefined
    selectedLayer: LayerT
    handleLegendClick: (newLayer: LayerT) => void
  }
}) => {
  if (!countryData) {
    return (
      <Card>
        <Text fontWeight='semibold'>Countries Types</Text>
        <Flex justifyContent={'center'} alignItems='center' h='100%'>
          <LoadingAnimation />
        </Flex>
      </Card>
    )
  }
  return (
    <StackedDiseasesByCountry
      selectCountry={selectCountry}
      filters={filters}
      data={countryData}
      layers={layers}
    />
  )
}

export default EpiDiseaseByCountry
